import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=7d5f2112&scoped=true&"
import script from "./SidebarLayout.vue?vue&type=script&lang=ts&"
export * from "./SidebarLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=7d5f2112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f2112",
  null
  
)

export default component.exports